import { Chip, Theme, useTheme } from "@mui/material";
import { FC } from "react";

const CompanyStage: FC<{ stage: string }> = ({ stage }) => {
  const theme: Theme = useTheme();

  const CompanyStageColors: Record<string, string> = {
    "Early Stage": theme.colors.yellow[50],
    "Achieved PMF and Scaling": theme.colors.green[50],
    "Approaching Product Market Fit": theme.colors.blue[100],
  };

  return (
    <Chip
      label={stage}
      style={{
        fontSize: 14,
        backgroundColor: CompanyStageColors[stage.trim()],
      }}
    />
  );
};

export default CompanyStage;
